module.exports = __webpack_public_path__ + "img/func5.d2f9fd30.png";